export default __webpack_public_path__ + "static/media/Ellipse 23 (3).bb6c9af0.png";